import { distance } from 'fastest-levenshtein';
import { ImportTutorsFormDataQuery } from '../client/gql/graphql';
import { ProfileQueryType } from '../components/Procurat/forms/ImportPersonsForm';
import { createForeignRefId, SyncMaster } from './create-foreignRefId';
import { onlyUnique } from './uniquByUuid';

export function findMatchingProfiles(
  profiles: ProfileQueryType[] | ImportTutorsFormDataQuery['profiles'] | undefined,
  person: {
    lastName?: string | null | undefined;
    firstName?: string | null | undefined;
    email?: string | null | undefined;
    personId: number;
  },
) {
  // already imported
  if (
    profiles?.some((p) =>
      p.foreignRefId?.some((f) => f === createForeignRefId(SyncMaster.procurat, person.personId.toString())),
    )
  ) {
    return [];
  }

  const byName =
    profiles?.filter(
      (p) =>
        (p.lastName === person.lastName &&
          (p.firstName?.includes(person.firstName ?? '') ||
            person.firstName?.includes(p.firstName ?? 'raising Distance'))) ||
        (p.firstName === person.firstName &&
          (p.lastName?.includes(person.lastName ?? '') || person.lastName?.includes(p.lastName ?? 'raising Distance'))),
    ) ?? [];
  const byMail = profiles?.filter((p) => p.email && p.email === person.email) ?? [];
  const byLevenshteinDistance =
    profiles?.filter(
      (p) =>
        distance(p.firstName ?? '', person.firstName ?? '') < 2 &&
        distance(p.lastName ?? '', person.lastName ?? '') < 2,
    ) ?? [];
  let matching = [...byName, ...byMail, ...byLevenshteinDistance].filter(onlyUnique);
  if (matching.length === 0) {
    matching = profiles ?? [];
  }
  return matching;
}
